export default "__VITE_ASSET__aBQx5sqb__ 600w";